import React, { Component, ReactNode } from 'react';
import Editor from '@monaco-editor/react';
import { RootState } from '../../../redux/store';
import { changeStruct, changeStructIsUpdate, clearStruct } from '../../../redux/actions/StructActions';
import { enterComponent, leaveComponent } from '../../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import CustomLoading from '../../custom/CustomLoading';
import ComponentName from '../../../constant/ComponentName';

class StructPreviewComponent extends Component<Props> {
  public render(): ReactNode {
    const {
      struct: { struct },
      preview,
    } = this.props;
    return (
      struct.properties?.variables?.length > 0 && (
        <div className={'flex flex-col w-full h-full items-start justify-start gap-y-5 px-5'} data-testid={`${ComponentName.STRUCT}_preview`}>
          <Editor options={{ readOnly: true }} className={'w-full h-full'} value={JSON.stringify(preview, null, 2)} language={'json'} />
        </div>
      )
    );
  }
}

interface Props extends ReduxProps {
  preview: Record<string, any>;
}

const mapStateToProps = (state: RootState) => ({
  struct: state.struct,
  isUpdate: state.struct.isUpdate,
  lastCategory: state.page.lastCategory,
});
const mapDispatchToProps = { changeStruct, clearStruct, changeStructIsUpdate, enterComponent, leaveComponent };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(StructPreviewComponent);
